import { render, staticRenderFns } from "./ProfileNavigation.vue?vue&type=template&id=860162be&scoped=true&"
import script from "./ProfileNavigation.vue?vue&type=script&lang=ts&"
export * from "./ProfileNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileNavigation.vue?vue&type=style&index=0&id=860162be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860162be",
  null
  
)

export default component.exports